/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddRoleDto,
  AvailableRolesDto,
  EntityNotFoundErrorDetailsErrorResponseModel,
  ErrorResponseModel,
  LoginResponseDto,
  LoginResponseUserBodyLoginResponseDto,
  ProblemDetails,
  RoleDto,
} from '../models/index';
import {
    AddRoleDtoFromJSON,
    AddRoleDtoToJSON,
    AvailableRolesDtoFromJSON,
    AvailableRolesDtoToJSON,
    EntityNotFoundErrorDetailsErrorResponseModelFromJSON,
    EntityNotFoundErrorDetailsErrorResponseModelToJSON,
    ErrorResponseModelFromJSON,
    ErrorResponseModelToJSON,
    LoginResponseDtoFromJSON,
    LoginResponseDtoToJSON,
    LoginResponseUserBodyLoginResponseDtoFromJSON,
    LoginResponseUserBodyLoginResponseDtoToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    RoleDtoFromJSON,
    RoleDtoToJSON,
} from '../models/index';

export interface RoleManagementAddRolePOSTRequest {
    addRoleDto?: AddRoleDto;
}

export interface RoleManagementGetUserAvailableRolesGETRequest {
    userId: string;
}

export interface RoleManagementGetUserRolesGETRequest {
    userId: string;
}

export interface RoleManagementRemoveRoleDELETERequest {
    roleId: string;
}

export interface RoleManagementSwitchRolePOSTRequest {
    roleId: string;
}

/**
 * RoleManagementApi - interface
 * 
 * @export
 * @interface RoleManagementApiInterface
 */
export interface RoleManagementApiInterface {
    /**
     * Creates request options for roleManagementAddRolePOST without sending the request
     * @param {AddRoleDto} [addRoleDto] 
     * @throws {RequiredError}
     * @memberof RoleManagementApiInterface
     */
    roleManagementAddRolePOSTRequestOpts(requestParameters: RoleManagementAddRolePOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {AddRoleDto} [addRoleDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleManagementApiInterface
     */
    roleManagementAddRolePOSTRaw(requestParameters: RoleManagementAddRolePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    roleManagementAddRolePOST(requestParameters: RoleManagementAddRolePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for roleManagementGetUserAvailableRolesGET without sending the request
     * @param {string} userId 
     * @throws {RequiredError}
     * @memberof RoleManagementApiInterface
     */
    roleManagementGetUserAvailableRolesGETRequestOpts(requestParameters: RoleManagementGetUserAvailableRolesGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleManagementApiInterface
     */
    roleManagementGetUserAvailableRolesGETRaw(requestParameters: RoleManagementGetUserAvailableRolesGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AvailableRolesDto>>>;

    /**
     */
    roleManagementGetUserAvailableRolesGET(requestParameters: RoleManagementGetUserAvailableRolesGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AvailableRolesDto>>;

    /**
     * Creates request options for roleManagementGetUserRolesGET without sending the request
     * @param {string} userId 
     * @throws {RequiredError}
     * @memberof RoleManagementApiInterface
     */
    roleManagementGetUserRolesGETRequestOpts(requestParameters: RoleManagementGetUserRolesGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleManagementApiInterface
     */
    roleManagementGetUserRolesGETRaw(requestParameters: RoleManagementGetUserRolesGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RoleDto>>>;

    /**
     */
    roleManagementGetUserRolesGET(requestParameters: RoleManagementGetUserRolesGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RoleDto>>;

    /**
     * Creates request options for roleManagementRemoveRoleDELETE without sending the request
     * @param {string} roleId 
     * @throws {RequiredError}
     * @memberof RoleManagementApiInterface
     */
    roleManagementRemoveRoleDELETERequestOpts(requestParameters: RoleManagementRemoveRoleDELETERequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} roleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleManagementApiInterface
     */
    roleManagementRemoveRoleDELETERaw(requestParameters: RoleManagementRemoveRoleDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    roleManagementRemoveRoleDELETE(requestParameters: RoleManagementRemoveRoleDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for roleManagementSwitchRolePOST without sending the request
     * @param {string} roleId 
     * @throws {RequiredError}
     * @memberof RoleManagementApiInterface
     */
    roleManagementSwitchRolePOSTRequestOpts(requestParameters: RoleManagementSwitchRolePOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} roleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleManagementApiInterface
     */
    roleManagementSwitchRolePOSTRaw(requestParameters: RoleManagementSwitchRolePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginResponseUserBodyLoginResponseDto>>;

    /**
     */
    roleManagementSwitchRolePOST(requestParameters: RoleManagementSwitchRolePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginResponseUserBodyLoginResponseDto>;

}

/**
 * 
 */
export class RoleManagementApi extends runtime.BaseAPI implements RoleManagementApiInterface {

    /**
     * Creates request options for roleManagementAddRolePOST without sending the request
     */
    async roleManagementAddRolePOSTRequestOpts(requestParameters: RoleManagementAddRolePOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/RoleManagement/add-role`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddRoleDtoToJSON(requestParameters['addRoleDto']),
        };
    }

    /**
     */
    async roleManagementAddRolePOSTRaw(requestParameters: RoleManagementAddRolePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.roleManagementAddRolePOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async roleManagementAddRolePOST(requestParameters: RoleManagementAddRolePOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.roleManagementAddRolePOSTRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for roleManagementGetUserAvailableRolesGET without sending the request
     */
    async roleManagementGetUserAvailableRolesGETRequestOpts(requestParameters: RoleManagementGetUserAvailableRolesGETRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling roleManagementGetUserAvailableRolesGET().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/RoleManagement/user/{userId}/available-roles`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async roleManagementGetUserAvailableRolesGETRaw(requestParameters: RoleManagementGetUserAvailableRolesGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AvailableRolesDto>>> {
        const requestOptions = await this.roleManagementGetUserAvailableRolesGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AvailableRolesDtoFromJSON));
    }

    /**
     */
    async roleManagementGetUserAvailableRolesGET(requestParameters: RoleManagementGetUserAvailableRolesGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AvailableRolesDto>> {
        const response = await this.roleManagementGetUserAvailableRolesGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for roleManagementGetUserRolesGET without sending the request
     */
    async roleManagementGetUserRolesGETRequestOpts(requestParameters: RoleManagementGetUserRolesGETRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling roleManagementGetUserRolesGET().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/RoleManagement/user/{userId}/roles`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async roleManagementGetUserRolesGETRaw(requestParameters: RoleManagementGetUserRolesGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RoleDto>>> {
        const requestOptions = await this.roleManagementGetUserRolesGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RoleDtoFromJSON));
    }

    /**
     */
    async roleManagementGetUserRolesGET(requestParameters: RoleManagementGetUserRolesGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RoleDto>> {
        const response = await this.roleManagementGetUserRolesGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for roleManagementRemoveRoleDELETE without sending the request
     */
    async roleManagementRemoveRoleDELETERequestOpts(requestParameters: RoleManagementRemoveRoleDELETERequest): Promise<runtime.RequestOpts> {
        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling roleManagementRemoveRoleDELETE().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/RoleManagement/remove-role/{roleId}`;
        urlPath = urlPath.replace(`{${"roleId"}}`, encodeURIComponent(String(requestParameters['roleId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async roleManagementRemoveRoleDELETERaw(requestParameters: RoleManagementRemoveRoleDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.roleManagementRemoveRoleDELETERequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async roleManagementRemoveRoleDELETE(requestParameters: RoleManagementRemoveRoleDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.roleManagementRemoveRoleDELETERaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for roleManagementSwitchRolePOST without sending the request
     */
    async roleManagementSwitchRolePOSTRequestOpts(requestParameters: RoleManagementSwitchRolePOSTRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling roleManagementSwitchRolePOST().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/RoleManagement/switch-role/{roleId}`;
        urlPath = urlPath.replace(`{${"roleId"}}`, encodeURIComponent(String(requestParameters['roleId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async roleManagementSwitchRolePOSTRaw(requestParameters: RoleManagementSwitchRolePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginResponseUserBodyLoginResponseDto>> {
        const requestOptions = await this.roleManagementSwitchRolePOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseUserBodyLoginResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async roleManagementSwitchRolePOST(requestParameters: RoleManagementSwitchRolePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginResponseUserBodyLoginResponseDto> {
        const response = await this.roleManagementSwitchRolePOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
